<script>
import { ref } from 'vue'
import { useStore, mapGetters } from 'vuex';
import {isEmpty} from "@/tools/utils";
// import ComOrg from './organization.vue'
export default {
    name: 'layout-base-header',
    computed:{
        ...mapGetters('user', ['userBase'])
    },
    // components: { ComOrg },
    setup(){
      let store = useStore();
      function logOut() {
        store.commit('user/logout');
        window.location.reload();
      }
      function isValueEmpty(value){
        return isEmpty(value);
      }
      return {
        logOut,
        isValueEmpty
      }
    }
}
</script>
<template>

    <q-header elevated class="bg-primary text-white" height-hint="64">
        <q-toolbar class="EDI__toolbar">
<!--            <q-btn dense round aria-label="主菜单" icon="fas fa-bars" class="q-mr-sm"-->
<!--            @click="$store.commit('page/change-left-menu-status')"></q-btn>-->
            <q-toolbar-title v-if="$q.screen.gt.xs" shrink class="row items-center no-wrap cursor-pointer">
                <img src="/static/frontimgs/logo-white.png">
                <span class="q-ml-sm text-weight-bolder">eMIS</span>
            </q-toolbar-title>
          <div class="my-quarantine"></div>
          <span class="my-company pl10" v-if="!isValueEmpty(userBase.company)">
            {{ userBase.company }}
          </span>
            <q-space />
            <div class="q-gutter-sm row items-center no-wrap">
              <span class="my-company" v-if="!isValueEmpty(userBase.FCustomer)">
                {{ userBase.FCustomer }}
                {{!isValueEmpty(userBase.FCustomer) && !isValueEmpty(userBase.FName) ? '，' : ''}}
              </span>
              <span class="my-company" v-if="!isValueEmpty(userBase.FName)">
                {{ userBase.FName }}
              </span>
              <q-btn round dense flat icon="fas fa-user" style="color: white">
                <q-tooltip anchor="top middle" self="bottom middle">用户信息</q-tooltip>
                <q-menu>
                  <div class="row no-wrap q-pa-md">
                    <div class="column items-center" style="min-width: 120px;">
                      <div class="text-subtitle1 q-mt-sm q-mb-xs">
                        用户：{{ userBase.name ? userBase.name : userBase.username }}
                      </div>
                      <q-btn class="q-mt-sm" color="primary" label="退出登录" push size="md" v-close-popup
                             icon="fas fa-sign-out-alt" @click="logOut()">
                      </q-btn>
                    </div>
                  </div>
                </q-menu>
              </q-btn>
            </div>
        </q-toolbar>
    </q-header>
</template>
<style lang="sass">
.pl10
  padding-left: 10px
.my-company
  display: inline-block
  font-size: 16px
  font-weight: 600
.my-quarantine
  height: 30px
  border-left: 3px solid white
.EDI
  &__toolbar
    img
        width: 89px
    .q-btn
        img
            width: 30px

</style>
